const complianceSubModules = [
    {id: 1, name: 'Spills', value: 'Spills'},
    {id: 1, name: 'Remediation', value: 'Remediation'},
    {id: 1, name: 'Complaints', value: 'Complaints'},
    {id: 1, name: 'Production', value: 'Production'},
    {id: 1, name: 'Inspection', value: 'Inspection'},
    {id: 1, name: 'Wildlife', value: 'Wildlife'}
]

export default complianceSubModules;